// ハルシネーション検知 S1 のフロント定数。
// バックエンドは上限を API 公開していないため（crawlDepth 0-2 / 最大100ページは block1 §7 の固定値）、
// FE 側の定数として持つ。将来 config エンドポイントが生えたら fetch 化する余地を残す。

import type { CrawlDepth } from '@/types/api/hallucination'

/** 1ソースあたりの最大取得ページ数（block1 §7・screen-design §5.1）。 */
export const HALLUCINATION_MAX_PAGES = 100

/** 一覧のページサイズ。 */
export const HALLUCINATION_SOURCES_PAGE_SIZE = 20
export const HALLUCINATION_PAGES_PAGE_SIZE = 20
/** セクション（チャンク）は3件ずつ（screen-design §4）。 */
export const HALLUCINATION_CHUNKS_PAGE_SIZE = 3

/** 進行中ソースのポーリング間隔（screen-design §6・30秒）。 */
export const HALLUCINATION_POLL_INTERVAL_MS = 30_000

/**
 * 「取り込めなかったページ一覧」を既定で畳む件数のしきい値（screen-design §3.3）。
 * ⚠️ **少数のときは開いたまま**にする＝理由が一目で分かる価値のほうが大きい。
 * 折りたたみの目的は「上限100ページまで失敗しうるので画面を占有させない」ことなので、
 * 占有が問題になる件数からだけ畳む。
 */
export const HALLUCINATION_ISSUES_COLLAPSE_THRESHOLD = 10

// --- S2 検知実行（block2 §6 / detection-start.service の定数と一致・UI 事前抑止用） ---
// BE は上限を API 公開していないため（block2 §6 の固定値）FE 定数として持つ。将来 config
// エンドポイントが生えたら fetch 化する余地を残す（S1 の HALLUCINATION_MAX_PAGES と同方針）。

/**
 * combination 総数の上限（＝プロンプト数 × 回答モデル数・block2 §6 maxPrompts）の**初期値/フォールバック**。
 * 正は**サーバ駆動**（readiness 応答 `maxCombinations`）。readiness ロード前のみこの値を使う（N-2）。
 */
export const DETECTION_MAX_COMBINATIONS = 100

/** 回答モデル選択数の範囲（block2 §6・1〜10）。 */
export const DETECTION_MIN_MODELS = 1
export const DETECTION_MAX_MODELS = 10

/** S3 検知ステータス一覧のページサイズ（block3・取り込み一覧と揃える）。 */
export const DETECTION_JOBS_PAGE_SIZE = 20

/** 取得範囲の選択肢（このページのみ／直接リンク先まで／さらに先）。 */
export const CRAWL_DEPTH_OPTIONS: readonly CrawlDepth[] = [0, 1, 2]

/** 登録ダイアログの初期選択（screen-design §5.1・「直接リンク先まで」）。 */
export const DEFAULT_CRAWL_DEPTH: CrawlDepth = 1
